import _isNil from 'lodash/isNil'
import numeral from 'numeral'

export const formatNumeric = (value: number, isCurrency: boolean) => {
  if (_isNil(value)) return ''

  return numeral(value).format(isCurrency ? '$0.00 a' : '0.0 a')
}
